<template>
  <b-modal id="task-modal" size="lg" :title="isUpdate ? 'Задача':'Новая задача'" hide-footer @shown="onShowModal">
    <b-form @submit="createTask" size="sm">
      <b-form-group label="Задача:" label-cols-sm="4" label-cols-lg="4">
        <b-textarea v-model="form.content" rows="3" max-rows="6"></b-textarea>
      </b-form-group>
      <b-form-group label="Статус:" label-cols-sm="4" label-cols-lg="4">
        <b-form-select v-model="form.status" required :options="statusOptions"></b-form-select>
      </b-form-group>
      <b-form-group label="Ответственный:" label-cols-sm="4" label-cols-lg="4">
        <multi-select
          v-model="form.responsible"
          :options="optionsResponsible"
          :searchable="true"
          :loading="isLoadingResponsible"
          :internal-search="false"
          :hide-selected="true"
          track-by="last_name"
          label="last_name"
          placeholder="Введите имя для поиска"
          selectLabel="Enter чтобы выбрать"
          @search-change="asyncFindResponsible"
        >
          <template slot="option" slot-scope="props">{{ contactFullName(props.option) }}</template>
          <template slot="noOptions">Начните вводить имя</template>
          <template slot="singleLabel" slot-scope="{ option }">{{ contactFullName(option) }}</template>
          <span slot="noResult">Не найдено</span>
        </multi-select>
      </b-form-group>
      <b-form-group label="Объект:" label-cols-sm="4" label-cols-lg="4">
        <b-form-select v-model="form.source" required :options="sourceOptions"
                       v-on:change="form.company = null;form.deal = null;form.contact = null;"></b-form-select>
      </b-form-group>

      <template v-if="form.source==='company'">
        <b-form-group label="Компания:" label-cols-sm="4" label-cols-lg="4">
          <multi-select
            v-model="form.company"
            :options="optionsCompany"
            :searchable="true"
            :loading="isLoadingCompany"
            :internal-search="false"
            :hide-selected="true"
            track-by="title"
            label="title"
            placeholder="Введите название для поиска"
            selectLabel="Enter чтобы выбрать"
            @search-change="asyncFindCompany"
          >
            <template slot="option" slot-scope="props"> {{ props.option.title }}</template>
            <template slot="noOptions">Начните вводить название</template>
            <template slot="singleLabel" slot-scope="{ option }">{{ option.title }}</template>
            <span slot="noResult">Не найдено</span>
          </multi-select>
        </b-form-group>
      </template>

      <template v-if="form.source==='deal'">
        <b-form-group label="Сделка:" label-cols-sm="4" label-cols-lg="4">
          <multi-select
            v-model="form.deal"
            :options="optionsDeal"
            :searchable="true"
            :loading="isLoadingDeal"
            :internal-search="false"
            :hide-selected="true"
            track-by="title"
            label="title"
            placeholder="Введите название для поиска"
            selectLabel="Enter чтобы выбрать"
            @search-change="asyncFindDeal"
          >
            <template slot="option" slot-scope="props"> {{ props.option.title }}</template>
            <template slot="noOptions">Начните вводить название</template>
            <template slot="singleLabel" slot-scope="{ option }">{{ option.title }}</template>
            <span slot="noResult">Не найдено</span>
          </multi-select>
        </b-form-group>
      </template>

      <template v-if="form.source==='contact'">
        <b-form-group label="Контакт:" label-cols-sm="4" label-cols-lg="4">
          <multi-select
            v-model="form.contact"
            :options="optionsContact"
            :searchable="true"
            :loading="isLoadingContact"
            :internal-search="false"
            :hide-selected="true"
            track-by="last_name"
            label="last_name"
            placeholder="Введите имя для поиска"
            selectLabel="Enter чтобы выбрать"
            @search-change="asyncFindContact"
          >
            <template slot="noOptions">Начните вводить имя</template>
            <template slot="singleLabel" slot-scope="{ option }">{{ contactFullName(option) }}</template>
            <template slot="option" slot-scope="props">{{ contactFullName(props.option) }}</template>
            <span slot="noResult">Не найдено</span>
          </multi-select>
        </b-form-group>
      </template>
      <b-form-group label="Выполнить:" label-cols-sm="4" label-cols-lg="4">
        <b-form-row>
          <b-col>
            <b-form-input
              v-model="dueDateTime"
              type="datetime-local"
            ></b-form-input>
            <div class="float-left">
              <small>
                <a class="link" @click="setDate('today')">Сегодня</a> |
                <a class="link" @click="setDate('tomorrow')">Завтра</a> |
                <a class="link" @click="setDate('week')">Неделя</a> |
                <a class="link" @click="setDate('month')">Месяц</a> |
                <a class="link" @click="setDate('year')">Год</a>
              </small>
            </div>
            <div class="float-right">
              <small>
                <span>через </span>
                <a class="link" @click="setTime('1h')">час</a> |
                <a class="link" @click="setTime('2h')">2ч</a> |
                <a class="link" @click="setTime('3h')">3ч</a> |
                <a class="link" @click="setTime('fullday')">весь день</a>
              </small>
            </div>
          </b-col>
        </b-form-row>
      </b-form-group>
      <b-alert v-model="error" dismissible variant="danger">{{ message }}</b-alert>
      <loading-button :is-busy="isBusyButton" :text="isUpdate ? 'Сохранить':'Создать'"></loading-button>
    </b-form>
  </b-modal>
</template>


<script>
import LoadingButton from "../components/LoadingButton";
import MultiSelect from 'vue-multiselect';
import commonMixin from '../mixins/common';
import 'vue2-datepicker/index.css';
import moment from 'moment';

export default {
  name: "TaskModal",
  mixins: [commonMixin],
  props: {
    form: Object,
    isUpdate: Boolean
  },
  components: {LoadingButton, MultiSelect},
  data() {
    return {
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      sourceOptions: [
        {value: 'deal', text: 'Сделка'},
        {value: 'company', text: 'Компания'},
        {value: 'contact', text: 'Контакт'},
      ],
      //isUpdate: false,
      isBusy: false,
      isBusyButton: false,
      isLoading: false,
      isLoadingDeal: false,
      isLoadingResponsible: false,
      isLoadingContact: false,
      isLoadingCompany: false,
      totalRows: 1,
      errorResult: null,
      messageResult: '',
      perPage: 20,
      currentPage: 1,
      error: false,
      message: '',
      fields: [
        {key: 'content', label: 'Задача'},
        {key: 'object', label: 'Объект'},
        {key: 'responsible', label: 'Ответственный'},
        {key: 'status', label: 'Статус'},
        {key: 'due_date', label: 'Срок'},
        {key: 'created_at', label: 'Создано'},
        {key: 'actions', label: 'Действия'}
      ],
      items: [],
      optionsResponsible: [],
      optionsDeal: [],
      optionsContact: [],
      optionsCompany: [],
      statusOptions: [
        {value: 'todo', text: 'К выполнению'},
        {value: 'done', text: 'Готово'},
      ],
    }
  },
  computed: {
    dueDateTime: {
      get: function () {
        return moment(this.form.due_date).format('YYYY-MM-DD[T]HH:mm')
      },
      set: function (value) {
        this.form.due_date = moment(value).toISOString()
      }
    },
  },
  methods: {
    onShowModal() {
      if (!this.isUpdate) {
        this.setDate('today');
      } else if (this.form.due_date) {
        this.dueDateTime = moment(this.form.due_date).format('YYYY-MM-DD[T]HH:mm');
      }
    },
    createTask(evt) {
      evt.preventDefault();
      this.error = false;
      this.isBusyButton = true;
      let promise = null;
      if (this.isUpdate) {
        promise = this.axios.post(process.env.VUE_APP_BACKEND_URL + '/api/tasks/' + this.form.id, JSON.stringify(this.form));
      } else {
        promise = this.axios.put(process.env.VUE_APP_BACKEND_URL + '/api/tasks/', JSON.stringify(this.form));
      }

      return promise.then((response) => {
        this.isBusyButton = false;
        if (response) {
          if (response.data.error === false) {
            this.error = false;
            this.$bvModal.hide('task-modal');
            this.$emit('refresh');
          } else {
            this.error = true;
            this.message = response.data.message;
          }
        }
      })
    },
    asyncFindResponsible(query) {
      this.isLoadingResponsible = true
      const promise = this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/users/?query=' + query);
      return promise.then(response => {
        this.optionsResponsible = response.data.users;
        this.isLoadingResponsible = false;
      }).catch((error) => {
        console.log(error);
        this.optionsResponsible = [];
        this.isLoadingResponsible = false;
      });
    },
    asyncFindContact(query) {
      this.isLoadingContact = true
      const promise = this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/contacts/?query=' + query);
      return promise.then(response => {
        this.optionsContact = response.data.contacts;
        this.isLoadingContact = false;
      }).catch((error) => {
        console.log(error);
        this.optionsContact = [];
        this.isLoadingContact = false;
      });
    },
    asyncFindCompany(query) {
      this.isLoadingCompany = true
      const promise = this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/companies/?query=' + query);
      return promise.then(response => {
        this.optionsCompany = response.data.companies;
        this.isLoadingCompany = false;
      }).catch((error) => {
        console.log(error);
        this.optionsCompany = [];
        this.isLoadingCompany = false;
      });
    },
    asyncFindDeal(query) {
      this.isLoadingDeal = true
      const promise = this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/deals/?query=' + query);
      return promise.then(response => {
        this.optionsDeal = response.data.deals;
        this.isLoadingDeal = false;
      }).catch((error) => {
        console.log(error);
        this.optionsDeal = [];
        this.isLoadingDeal = false;
      });
    },
    setTime(value) {
      if (value === 'fullday') {
        this.dueDateTime = moment(this.form.due_date).format('YYYY-MM-DD[T23:59]');
      } else if (value === '1h') {
        this.dueDateTime = moment().add(1, 'hours').format('YYYY-MM-DD[T]HH:mm');
      } else if (value === '2h') {
        this.dueDateTime = moment().add(2, 'hours').format('YYYY-MM-DD[T]HH:mm');
      } else if (value === '3h') {
        this.dueDateTime = moment().add(3, 'hours').format('YYYY-MM-DD[T]HH:mm');
      }
    },
    setDate(value) {
      if (value === 'today') {
        this.dueDateTime = moment().format('YYYY-MM-DD[T23:59]');
      } else if (value === 'tomorrow') {
        this.dueDateTime = moment().add(1, 'days').format('YYYY-MM-DD[T23:59]');
      } else if (value === 'week') {
        this.dueDateTime = moment().add(7, 'days').format('YYYY-MM-DD[T23:59]');
      } else if (value === 'month') {
        this.dueDateTime = moment().add(1, 'months').format('YYYY-MM-DD[T23:59]');
      } else if (value === 'year') {
        this.dueDateTime = moment().add(1, 'years').format('YYYY-MM-DD[T23:59]');
      }
    }
  }
}
</script>

<style scoped>
.link {
  cursor: pointer;
}
</style>
